import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../../../services/api";
import { RelationshipPaths } from "../@types/relationshippaths";

interface RelationshipQueryParams {
  r: number | string;
  hashValue: string;
}

const useGetRelationshipPaths = (
  hashValue: string,
  queryParams: RelationshipQueryParams
) => {
  const { data: paths = [] } = useQuery({
    queryKey: ["getRelationshipPath", hashValue, queryParams],
    queryFn: () =>
      api.getRelationshipPath({
        hashValue,
        queryParams
      }),
    select: ({ data }: AxiosResponse<RelationshipPaths>) => data?.paths
  });

  return { paths };
};

export default useGetRelationshipPaths;
